import { render } from "./error-bubble.vue?vue&type=template&id=41f748f7"
import script from "./error-bubble.vue?vue&type=script&lang=js"
export * from "./error-bubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__